module.exports = __webpack_public_path__ + "static/media/inputdaterange.5bc6622a.png";